import AnswerBlockLabel from "./AnswerBlockLabel";
import { useSelector } from "react-redux";

const AnswerBlock = ({ data, answerText }) => {
  const { currentQuestion, result } = useSelector((state) => state.data);

  const handleOnChoiceClick = (item) => {
    let d = {
      questions: result,
      answer: "",
      current_questionid: currentQuestion.questionId.toString(),
      skipped: false,
      choices: ["coding"],
    };
    console.log(
      d,
      item,
      currentQuestion.questionId.toString(),
      currentQuestion.choices,
      "checking",
    );
  };

  return (
    <div>
      {data?.choices?.map((item, index) =>
        item.isSelected ? (
          <AnswerBlockLabel
            key={`AnswerBlockLabel-${index}`}
            onChoiceClick={handleOnChoiceClick}
            data={item}
            id={`AnswerBlockLabel-${index}`}
            text={item.choiceText}
          />
        ) : null,
      )}
    </div>
  );
};

export default AnswerBlock;
